import { animated, useSpring } from "@react-spring/web";
import Skeleton from "react-loading-skeleton";

// Containers
import CategoryNavigationContainer from "containers/molecules/CategoryNavigationContainer";
import ProviderNavigationContainer from "containers/molecules/ProviderNavigationContainer";

// Icons
import ArrowLeft from "assets/icons/arrow.svg?react";

import "./styles.sass";
import classNames from "classnames";

type SidebarTypes = {
  isLoading: boolean;
  isSidebarOpen: boolean;
  onToggle: (isSidebarOpen: boolean) => void;
  hasLoyalty?: boolean;
};

const Sidebar = (props: SidebarTypes) => {
  const { isSidebarOpen, isLoading, onToggle, hasLoyalty = false } = props;
  const { width, transform } = useSpring({
    width: isSidebarOpen ? 256 : 76,
    transform: `rotate(${isSidebarOpen ? 0 : 180}deg)`,
  });

  const handleToggle = () => {
    onToggle(!isSidebarOpen);
  };

  const classNameToggle = classNames(
    "Sidebar__toggle",
    hasLoyalty && "Sidebar__toggle_loyalty",
  );

  return (
    <animated.div className="Sidebar__wrapper" style={{ width }}>
      <div className={classNameToggle} onClick={handleToggle}>
        {isLoading ? (
          <Skeleton width={36} height={36} />
        ) : (
          <animated.div className="Sidebar__arrow" style={{ transform }}>
            <ArrowLeft />
          </animated.div>
        )}
      </div>
      <animated.div className="Sidebar" style={{ width }}>
        <div className="Sidebar__navigation">
          <CategoryNavigationContainer />
        </div>
        {!isLoading && (
          <div className="Sidebar__providers">
            <ProviderNavigationContainer />
          </div>
        )}
      </animated.div>
    </animated.div>
  );
};

export default Sidebar;
